var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from '../framework/Framework';
import { Component } from '../framework/Component';
export class MenuComponent extends Component {
    constructor() {
        super('MenuComponent', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.menu-item-has-children').on('mouseenter', (event, item) => {
                const childContainer = $(item).find('.children').get(0);
                childContainer.style.maxHeight = childContainer.scrollHeight + 'px';
            }).on('mouseleave', (event, item) => {
                $(item).find('.children').get(0).style.maxHeight = '0';
            });
            $('.menu-item-has-children > a').on('click', (event, item) => {
                if (window.innerWidth < 991) {
                    event.preventDefault();
                    const childContainer = $(item).next().get(0);
                    if (getComputedStyle(childContainer).maxHeight == '0px' || getComputedStyle(childContainer).maxHeight == '') {
                        childContainer.style.maxHeight = childContainer.scrollHeight + 'px';
                    }
                    else {
                        childContainer.style.maxHeight = '0';
                    }
                }
            });
            $('#button-toggle-menu').on('click', (event, item) => {
                $(item).toggleClass('active');
                $('#main-menu').toggleClass('opened');
            });
            this.success();
        });
    }
}
